import { render, staticRenderFns } from "./_base-gauge.vue?vue&type=template&id=672478bc&scoped=true&"
import script from "./_base-gauge.vue?vue&type=script&lang=js&"
export * from "./_base-gauge.vue?vue&type=script&lang=js&"
import style0 from "./_base-gauge.vue?vue&type=style&index=0&id=672478bc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672478bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('672478bc')) {
      api.createRecord('672478bc', component.options)
    } else {
      api.reload('672478bc', component.options)
    }
    module.hot.accept("./_base-gauge.vue?vue&type=template&id=672478bc&scoped=true&", function () {
      api.rerender('672478bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base-gauge.vue"
export default component.exports